export enum ChecklistePositionPrioritaet {
  NIEDRIG = 'NIEDRIG',
  NORMAL = 'NORMAL',
  HOCH = 'HOCH',
}
